module.exports = __webpack_public_path__ + "static/5-fd58e1f4e5b640286adbd6dd835819e1.svg";